// extracted by mini-css-extract-plugin
module.exports = {"wraparound":"WraparoundProduct_wraparound___ulN1","pictures":"WraparoundProduct_pictures__pIc2z"};